// extracted by mini-css-extract-plugin
module.exports = {"list":"cow-list_list__3RY8I","list-item":"cow-list_list-item__1Hw_q","selected":"cow-list_selected__3vEUy"};